import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './FeatureL2.css';
import a from './cloud-done.png';
import b from './TI-DONE.png';
import c from './COLLEGE-DONE.png';
import d from './Disaster.png';
import e from './Managed.png';
import f from './Monitoring.png';
import g from './automation.png';
import h from './IT.png';
import i from './GA.PNG';

const features = [
  {
    icon: 'las la-search',
    background: "linear-gradient(135deg, #6B73FF 0%, #000DFF 100%)",
    title: "תכנון ומחקר",
    description: "מחקרים וניתוח נתונים תוך תכנון מושכל ואסטרטגי להצלחה המרבית שלנו",
    delay: 0.2,
    path: "/he/consulting"
  },
  {
    icon: 'las la-code',
    background: "linear-gradient(135deg, #FF6B6B 0%, #FF000F 100%)",
    title: "פיתוח תוכנה",
    description: "אנחנו מתמחים בהפיכת הרעיונות שלכם למציאות באמצעות טכנולוגיות מתקדמות",
    delay: 0.3,
    path: "/he/development"
  },
  {
    icon: 'las la-cogs',
    background: "linear-gradient(135deg, #36D1DC 0%, #5B86E5 100%)",
    title: "דבאופס",
    description: "אנחנו מנהלים את התפעול ואת הצמיחה של הרעיון שלכם, דואגים למסע חלק וביצועים גבוהים",
    delay: 0.4,
    path: "/he/operations"
  },
  {
    icon: 'las la-plug',
    background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
    title: "אינטגרציות",
    description: "חיבור לפעולות שלך על ידי אינטגרציה חלקה של מערכות שונות, יוצרים תהליך עבודה יעיל ומאורגן",
    delay: 0.5,
    path: "/he/development"
  },
  {
    icon: 'las la-shield-alt',
    background: "linear-gradient(135deg, #8E2DE2 0%, #4A00E0 100%)",
    title: "סייבר",
    description: "עם אבטחה בראש סדר העדיפויות שלנו, אנו מתכננים כל נקודת מגע עם שיקול דעת מירבי",
    delay: 0.6,
    path: "/he/security"
  },
  {
    icon: 'las la-headset',
    background: "linear-gradient(135deg, #F2994A 0%, #F2C94C 100%)",
    title: "ייעוץ ותמיכה",
    description: "אנחנו משמשים כשותפי ייעוץ ותמיכה, מציעים פתרונות מומחים כשאתם צריכים",
    delay: 0.7,
    path: "/he/consulting"
  },
  {
    icon: 'las la-cloud',
    background: "linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)",
    title: "ענן פרטי",
    description: "הקמה וניהול של פתרונות ענן פרטי ואחסון מאובטחים, עם שליטה מלאה.",
    delay: 0.8,
    path: "/he/private_cloud"
  },
  {
    icon: 'las la-database',
    background: "linear-gradient(135deg, #1f4037 0%, #99f2c8 100%)",
    title: "תשתיות DataOps",
    description: "הופכים דאטה גולמי לתהליך עסקי מובנה, אמין ואוטומטי לארגונים חכמים.",
    delay: 0.9,
    path: "/he/dataops"
  },
  {
    icon: 'las la-network-wired',
    background: "linear-gradient(135deg, #b20a2c 0%, #fffbd5 100%)",
    title: "מרכז בקרה (NOC)",
    description: " בקרה וניטור פרואקטיבי שעוקב אחר התשתיות העסקיות שלך כל העת.",
    delay: 1.0,
    path: "/he/noc"
  },
  {
    icon: 'las la-server',
    background: "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)",
    title: "ניהול שרתים",
    description: "תחזוקה מקיפה לשרתים ולמשאבי המחשוב שלך – ServerCare Plus לשקט נפשי.",
    delay: 1.1,
    path: "/he/managed_service"
  },
  {
    icon: 'las la-life-ring',
    background: "linear-gradient(135deg, #f12711 0%, #f5af19 100%)",
    title: "התאוששות מאסון",
    description: "תוכנית גיבוי והמשכיות עסקית (DRP) המבטיחה התאוששות מיידית בזמן חירום.",
    delay: 1.2,
    path: "/he/disaster_recovery"
  },
  {
    icon: 'las la-graduation-cap',
    background: "linear-gradient(135deg, #8360c3 0%, #2ebf91 100%)",
    title: "אקדמיה והכשרות",
    description: "מצוינות בקצה האצבעות. מערכי למידה טכנולוגיים המותאמים אישית לצוותים מודרניים.",
    delay: 1.3,
    path: "/he/academy"
  }
];

function FeatureL2he() {
  const navigate = useNavigate();
  const spotlightTrackRef = useRef(null);
  const [isHebrewPromoPlaying, setIsHebrewPromoPlaying] = useState(false);

  const handleSmbPromoClick = (event, url) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      event.preventDefault();
      var callback = function () {
        if (typeof (url) != 'undefined') {
          window.location = url;
        }
      };
      window.gtag('event', 'conversion', {
        'send_to': 'AW-11461100984/6yv5CM2TnpgcELiLitkq',
        'value': 50.0,
        'currency': 'ILS',
        'event_callback': callback
      });
      return false;
    }

    return true;
  };

  const scrollToFeature = (targetIndex) => {
    const track = spotlightTrackRef.current;

    if (!track) {
      return;
    }

    const boundedIndex = Math.max(0, Math.min(targetIndex, features.length - 1));
    const targetCard = track.querySelector(`[data-feature-index="${boundedIndex}"]`);

    if (!targetCard) {
      return;
    }

    setActiveFeatureIndex(boundedIndex);
    targetCard.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  };

  const scrollSpotlightTrack = (direction) => {
    const nextIndex = direction === 'next'
      ? activeFeatureIndex + 1
      : activeFeatureIndex - 1;

    scrollToFeature(nextIndex);
  };

  const partnerWords = [
    "הטכנולוגי",
    "לארכיטקטורה",
    "לתשתיות",
    "לענן",
    "לאופרציה",
    "לפיתוח",
    "לאינטגרציות",
    "לסקייל",
    "לסייבר",
    "לניטור",
    "ליציבות"
  ];

  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [activeFeatureIndex, setActiveFeatureIndex] = useState(0);

  const isIOS = typeof navigator !== "undefined" && (/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
  const textVariants = isIOS ? {
    enter: { opacity: 0 },
    center: { opacity: 1 },
    exit: { opacity: 0 }
  } : {
    enter: { opacity: 0, x: 30, filter: 'blur(0px)' },
    center: { opacity: 1, x: 0, filter: 'blur(0px)' },
    exit: { opacity: 0, x: -30, filter: 'blur(0px)' }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentWordIndex((prev) => (prev + 1) % partnerWords.length);
    }, 2500);
    return () => clearInterval(intervalId);
  }, [partnerWords.length]);

  useEffect(() => {
    const track = spotlightTrackRef.current;

    if (!track) {
      return undefined;
    }

    const updateActiveCard = () => {
      const cards = Array.from(track.querySelectorAll('[data-feature-index]'));

      if (!cards.length) {
        return;
      }

      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + (trackRect.width / 2);

      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const cardCenter = cardRect.left + (cardRect.width / 2);
        const distance = Math.abs(trackCenter - cardCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      setActiveFeatureIndex(closestIndex);
    };

    updateActiveCard();
    track.addEventListener('scroll', updateActiveCard, { passive: true });
    window.addEventListener('resize', updateActiveCard);

    return () => {
      track.removeEventListener('scroll', updateActiveCard);
      window.removeEventListener('resize', updateActiveCard);
    };
  }, []);

  // SEO Schema Data
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "EpicFinal",
    "description": "פתרונות תוכנה מתקדמים וחדשנות דיגיטלית לעסקים וסטארטאפים",
    "url": "https://epicfinal.com/he",
    "sameAs": [
      "https://boarding.epicfinal.com",
      "https://meetings.hubspot.com/viacheslav-seifer"
    ],
    "offers": {
      "@type": "Offer",
      "name": "שירותי פיתוח ותכנון דיגיטלי",
      "description": "פתרונות תוכנה מקצה לקצה לעסקים וסטארטאפים"
    }
  };

  // Non-visual SEO enhancements
  const seoKeywords = [
    // Software development
    "פיתוח תוכנה", "הנדסת תוכנה", "פיתוח תוכנה בהתאמה אישית", "הנדסת תוכנה לחברות",
    "חברת פיתוח תוכנה בתל אביב", "חברת פיתוח תוכנה בחיפה", "חברת פיתוח תוכנה בירושלים",
    "פיתוח פול סטאק", "React", "Node.js", ".NET", "Python", "אינטגרציות תוכנה", "API",
    "עלות פיתוח תוכנה", "כמה עולה פיתוח תוכנה", "הצעת מחיר לפיתוח תוכנה",
    "מיקור חוץ פיתוח תוכנה", "קבלן משנה פיתוח", "Microservices", "Event-Driven",
    "Code Review", "בדיקת קוד",
    // Web
    "בניית אתרים", "פיתוח אתרים", "WordPress", "WooCommerce", "Shopify", "Magento",
    "בניית אתרים לעסקים", "חברת בניית אתרים בגוש דן", "הרצליה", "רעננה",
    "עיצוב אתרים", "UI/UX", "פיתוח מרובה שפות", "RTL",
    "עלות בניית אתר", "קידום אתרים טכני", "Technical SEO", "תחזוקת אתרים", "מיגרציית אתר",
    // Apps
    "פיתוח אפליקציות", "פיתוח אפליקציות מובייל", "iOS", "Android",
    "React Native", "Flutter", "PWA", "עלות פיתוח אפליקציה", "הצעת מחיר לפיתוח אפליקציה",
    // Cloud/DevOps
    "DevOps", "CI/CD", "Docker", "Kubernetes", "Terraform", "Infrastructure as Code",
    "מחשוב ענן", "AWS", "Azure", "GCP", "ניטור", "Observability", "VPS", "שרת ייעודי",
    // Consulting/Architecture/IT
    "ייעוץ תוכנה", "ארכיטקטורת תוכנה", "ייעוץ מערכות מידע", "CTO כשירות", "CIO כשירות",
    "Due Diligence", "Cloud Readiness", "FinOps", "תמחור פרויקטי תוכנה", "ניהול פרויקט תוכנה",
    // Security
    "אבטחת מידע", "Cyber", "SOC", "SIEM", "SOAR", "EDR", "XDR", "בדיקות חדירה",
    "IAM", "Zero Trust", "ISO 27001", "הקשחת שרתים",
    // QA
    "QA", "בדיקות תוכנה", "בדיקות אוטומטיות", "SDET", "UAT", "בדיקות ביצועים",
    // Hosting & Infrastructure Services
    "אחסון אתרים", "אחסון אתרים בישראל", "שרת אחסון", "אחסון מהיר", "אחסון מאובטח",
    "SSL חינם", "Cloudflare", "אינטגרציה עם Cloudflare", "פאנל ניהול", "cPanel",
    "אחסון וורדפרס", "אחסון WordPress", "WordPress מנוהל", "וורדפרס מנוהל",
    "אחסון זול", "אחסון אתרים זול", "אחסון משתלם", "אחסון לעסקים",
    // VPS & Virtual Servers
    "שרתים וירטואליים", "VPS", "שרת וירטואלי", "VPS ישראל", "שרת VPS",
    "שרת Core", "שרת Edge", "שרת MTI-L", "vCPU", "RAM", "NVMe SSD",
    "גישת ROOT", "IPv4 יעודית", "שרת עם ROOT", "שרת לינוקס", "שרת Windows",
    // Managed Services
    "שירותים מנוהלים", "ניהול שרתים", "ניהול תשתיות ענן", "CDN מנוהל",
    "ניהול AWS", "ניהול Azure", "ניהול Google Cloud", "Aurora מנוהל", "מסד נתונים מנוהל",
    "ניטור 24/7", "ניטור שרתים", "גיבוי מרכזי", "DevOps כשירות", "DevOps לפי דרישה",
    // Cyber Defence Services
    "הגנת סייבר מנוהלת", "שירות הגנת סייבר", "SOC מנוהל", "SOC כשירות",
    "זיהוי איומים", "תגובה לאירועי סייבר", "Ransomware הגנה", "הגנה מפני כופרה",
    "ניטור נקודות קצה", "Endpoint Security", "Windows Security", "Linux Security",
    "אבטחת זהויות", "Microsoft Defender", "MDR", "Managed Detection Response"
  ];

  const schemaGraph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "name": "EpicFinal",
        "url": "https://epicfinal.com/",
        "inLanguage": "he-IL",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://epicfinal.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "ProfessionalService",
        "name": "EpicFinal",
        "url": "https://epicfinal.com/he",
        "areaServed": ["ישראל", "תל אביב", "חיפה", "ירושלים"],
        "serviceType": [
          "פיתוח תוכנה", "בניית אתרים", "פיתוח אפליקציות", "DevOps", "אבטחת מידע",
          "אחסון אתרים", "שרתים וירטואליים", "שירותים מנוהלים", "הגנת סייבר"
        ],
        "sameAs": [
          "https://boarding.epicfinal.com",
          "https://meetings.hubspot.com/viacheslav-seifer"
        ],
        "offers": [
          { "@type": "Offer", "name": "פיתוח תוכנה מותאם אישית" },
          { "@type": "Offer", "name": "בניית אתרים לעסקים" },
          { "@type": "Offer", "name": "DevOps וענן" },
          { "@type": "Offer", "name": "אחסון אתרים", "price": "19.90", "priceCurrency": "ILS", "description": "אחסון מהיר ומאובטח עם SSL אוטומטי ואינטגרציה עם Cloudflare" },
          { "@type": "Offer", "name": "שרתים וירטואליים VPS", "description": "שרתים וירטואליים עוצמתיים עם 4-16 vCPU, 8-35GB RAM וגישת ROOT מלאה" },
          { "@type": "Offer", "name": "WordPress מנוהל", "price": "19.90", "priceCurrency": "ILS", "description": "אחסון WordPress עם עדכונים אוטומטיים ומערכת הגנה" },
          { "@type": "Offer", "name": "שירותים מנוהלים", "description": "ניהול תשתיות ענן ושרתים עם ניטור 24/7 ותמיכה DevOps" },
          { "@type": "Offer", "name": "הגנת סייבר מנוהלת 24/7", "description": "שירות הגנה עם ניטור נקודות קצה, זיהוי איומים ותגובה מודרכת - עד 50 נקודות קצה, Windows ו-Linux" }
        ]
      }
    ]
  };

  // Hosting & Managed Services Schema
  const hostingServicesSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "שירותי אחסון וניהול",
    "description": "פתרונות אחסון, שרתים וירטואליים ושירותים מנוהלים מבית EpicFinal",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "item": {
          "@type": "Product",
          "name": "אחסון אתרים",
          "description": "פתרונות אחסון מהירים ומאובטחים לאתרים ויישומים עם פאנל ניהול מתקדם, מערכת הגנה, SSL אוטומטי ואינטגרציה עם Cloudflare",
          "offers": { "@type": "Offer", "price": "19.90", "priceCurrency": "ILS", "priceValidUntil": "2025-12-31", "availability": "https://schema.org/InStock" }
        }
      },
      {
        "@type": "ListItem",
        "position": 2,
        "item": {
          "@type": "Product",
          "name": "שרתים וירטואליים VPS",
          "description": "שרתים וירטואליים עוצמתיים עם משאבים ייעודיים: Core (4 vCPU, 8GB RAM), Edge (8 vCPU, 16GB RAM), MTI-L (16 vCPU, 35GB RAM). פאנל ניהול, גישת ROOT מלאה, IPv4 יעודית",
          "offers": { "@type": "AggregateOffer", "lowPrice": "64.90", "highPrice": "270.90", "priceCurrency": "USD", "availability": "https://schema.org/InStock" }
        }
      },
      {
        "@type": "ListItem",
        "position": 3,
        "item": {
          "@type": "Product",
          "name": "WordPress מנוהל ולא מנוהל",
          "description": "פתרונות WordPress עם פאנל ניהול, עדכונים אוטומטיים, מערכת הגנה, SSL אוטומטי ואינטגרציה עם Cloudflare",
          "offers": { "@type": "Offer", "price": "19.90", "priceCurrency": "ILS", "priceValidUntil": "2025-12-31", "availability": "https://schema.org/InStock" }
        }
      },
      {
        "@type": "ListItem",
        "position": 4,
        "item": {
          "@type": "Service",
          "name": "שירותים מנוהלים",
          "description": "ניהול מקצועי לתשתיות ענן ושרתים עם תמיכה מלאה, ניטור 24/7 ומומחיות DevOps. כולל CDN מנוהל Cloudflare, ניהול שרתים חיצוניים, ניהול AWS, מסד נתונים Aurora ועוד",
          "provider": { "@type": "Organization", "name": "EpicFinal" }
        }
      },
      {
        "@type": "ListItem",
        "position": 5,
        "item": {
          "@type": "Service",
          "name": "שירות הגנת סייבר מנוהל",
          "description": "שירות הגנה מנוהל 24/7 עם ניטור רציף, זיהוי איומים ותגובה מודרכת לנקודות קצה וזהויות. תמיכה ב-Windows ו-Linux, עד 50 נקודות קצה. ניטור פעילות משתמשים, חקירות איומים, זיהוי Ransomware",
          "provider": { "@type": "Organization", "name": "EpicFinal" }
        }
      }
    ]
  };

  // FAQ Schema for Hosting Services
  const hostingFAQSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "מה כולל שירות אחסון האתרים של EpicFinal?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "שירות אחסון האתרים כולל פאנל ניהול מתקדם, מערכת הגנה, SSL אוטומטי, אינטגרציה עם Cloudflare, ותמיכה טכנית. המחיר מתחיל מ-₪19.90 לחודש."
        }
      },
      {
        "@type": "Question",
        "name": "אילו תוכניות שרתים וירטואליים (VPS) זמינות?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "מציעים 3 תוכניות VPS: שרת Core עם 4 vCPU ו-8GB RAM, שרת Edge עם 8 vCPU ו-16GB RAM, ושרת MTI-L עם 16 vCPU ו-35GB RAM. כל השרתים כוללים פאנל ניהול, גישת ROOT מלאה וכתובת IPv4 יעודית."
        }
      },
      {
        "@type": "Question",
        "name": "מה ההבדל בין WordPress מנוהל ללא מנוהל?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "WordPress מנוהל כולל עדכונים אוטומטיים, גיבויים ותמיכה טכנית מלאה. WordPress לא מנוהל מתאים למפתחים שרוצים שליטה מלאה ומעדיפים לנהל בעצמם את העדכונים והתחזוקה."
        }
      },
      {
        "@type": "Question",
        "name": "מה כולל שירות הגנת הסייבר המנוהל?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "שירות הגנת סייבר מנוהל 24/7 עם ניטור רציף של נקודות קצה ופעילות משתמשים, חקירות איומים מובלות על ידי אנליסטים אנושיים, זיהוי מוקדם של איומים כולל Ransomware, והנחיות לבלימה ותיקון. השירות תומך ב-Windows ו-Linux עד 50 נקודות קצה."
        }
      },
      {
        "@type": "Question",
        "name": "אילו שירותים מנוהלים נוספים זמינים?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "השירותים המנוהלים כוללים: CDN מנוהל עם Cloudflare, ניהול שרתים חיצוניים, ניהול AWS אוטומטי, מסד נתונים Aurora מנוהל, ניטור וגיבוי מרכזי, ומנוי DevOps לפי דרישה. כל השירותים כוללים ניטור 24/7 ותמיכה מקצועית."
        }
      }
    ]
  };

  return (
    <div className="modern-feature-section rtl-section pan-theme">
      <Helmet htmlAttributes={{ lang: 'he' }}>
        <title>EpicFinal – פיתוח תוכנה, אחסון אתרים, שרתים VPS ושירותים מנוהלים | ישראל</title>
        <meta name="description" content="EpicFinal – פיתוח תוכנה, אחסון אתרים מ-₪19.90, שרתים וירטואליים VPS, WordPress מנוהל, שירותי ענן ו-DevOps, הגנת סייבר 24/7. ניטור, תמיכה מלאה ומומחיות בכל הארץ." />
        <meta name="keywords" content={seoKeywords.join(", ")} />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta property="og:title" content="EpicFinal – פיתוח תוכנה, אחסון אתרים, VPS ושירותים מנוהלים" />
        <meta property="og:description" content="פתרונות מקצה לקצה: אחסון אתרים מ-₪19.90, שרתים VPS, WordPress, שירותים מנוהלים והגנת סייבר 24/7. ניטור ותמיכה מלאה." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://epicfinal.com/he" />
        <meta property="og:locale" content="he_IL" />
        <meta property="og:site_name" content="EpicFinal" />
        <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
        <meta property="og:image:alt" content="EpicFinal – אחסון אתרים, שרתים VPS, שירותים מנוהלים והגנת סייבר" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="EpicFinal – אחסון, VPS, שירותים מנוהלים והגנת סייבר" />
        <meta name="twitter:description" content="אחסון אתרים מ-₪19.90, שרתים VPS, WordPress מנוהל, שירותי ענן והגנת סייבר 24/7. ניטור ותמיכה מלאה." />
        <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://epicfinal.com/he" />
        <link rel="alternate" href="https://epicfinal.com/he" hrefLang="he-IL" />
        <link rel="alternate" href="https://epicfinal.com/" hrefLang="en" />
        <link rel="alternate" href="https://epicfinal.com/" hrefLang="x-default" />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">{JSON.stringify(schemaGraph)}</script>
        <script type="application/ld+json">{JSON.stringify(hostingServicesSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(hostingFAQSchema)}</script>
      </Helmet>

      {/* Hero Section */}
      <motion.div
        className="hero-section epic-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        {/* Animated Background Effects */}
        <div className="hero-bg-effects">
          <div className="gradient-orb orb-1"></div>
          <div className="gradient-orb orb-2"></div>
          <div className="gradient-orb orb-3"></div>
          <div className="floating-grid"></div>
        </div>

        {/* Top Announcement Banner moved to Hebrew custom header */}
        <Container>
          <Row className="align-items-center justify-content-center min-vh-100">
            <Col lg={10} xl={9}>
              <motion.div
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 1, delay: 0.2 }}
                className="hero-content-epic"
              >


                {/* Badge */}
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.3, type: "spring" }}
                  className="hero-badge-epic"
                >
                  <span className="badge-icon"></span>
                  <span className="badge-text">פתרונות תוכנה, ענן ואבטחה לעסקים וסטארטאפים — משלב ההקמה ועד Production.</span>
                  <span className="badge-glow"></span>
                </motion.div>

                {/* Main Title */}
                <motion.h1
                  className="hero-title-epic"
                  initial={{ y: 30, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 1, delay: 0.5 }}
                >
                  <span className="title-line">
                    <span className="gradient-text-primary">השותף</span>
                  </span>
                  <span className="title-line">
                    {isIOS ? (
                      <span className="gradient-text-primary">הטכנולוגי</span>
                    ) : (
                      <span style={{ display: 'inline-grid', justifyItems: 'center', alignItems: 'center' }}>
                        {partnerWords.map(word => (
                          <span key={`hidden-${word}`} style={{ gridArea: '1 / 1', visibility: 'hidden', pointerEvents: 'none', whiteSpace: 'nowrap', display: 'inline-block' }}>
                            <span className="gradient-text-primary">{word}</span>
                          </span>
                        ))}
                        <AnimatePresence>
                          <motion.span
                            key={currentWordIndex}
                            initial={{ opacity: 0, x: 30 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -30 }}
                            transition={{ duration: 0.5, ease: "easeOut" }}
                            style={{
                              gridArea: '1 / 1',
                              whiteSpace: 'nowrap',
                              display: 'inline-block'
                            }}
                          >
                            <span className="gradient-text-primary" style={{ display: 'inline-block' }}>{partnerWords[currentWordIndex]}</span>
                          </motion.span>
                        </AnimatePresence>
                      </span>
                    )}
                  </span>
                  <span className="title-line">
                    <span className="gradient-text-primary">שלך</span>
                  </span>
                  <span className="title-line">
                    <span className="gradient-text-secondary">בית התוכנה אפיק פינאל </span>
                  </span>
                </motion.h1>



                {/* Description */}
                <motion.p
                  className="hero-description-epic"
                  initial={{ y: 30, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 1, delay: 0.7 }}
                >
                  מלווים יזמים, סטארטאפים ובעלי עסקים להצלחה בעולם הדיגיטלי המתפתח.
                  <br />
                  <span className="highlight-text">שירותי תוכנה מקצה לקצה</span>, <span className="text-gradient-pink">החזון שלך</span> – <span className="text-gradient-green">המומחיות שלנו</span> – <strong>בוא נצמח יחד</strong>.
                </motion.p>

                {/* CTA Buttons */}
                <motion.div
                  className="hero-cta-epic"
                  initial={{ y: 30, opacity: 0 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.9 }}
                >
                  <Link
                    to="/he/consulting#epic-consulting-form"
                    className="btn-epic-primary"
                  >
                    <motion.span
                      className="btn-content"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <span className="btn-text">השאר פרטים</span>
                      <i className="las la-edit btn-icon"></i>
                      <span className="btn-shine"></span>
                    </motion.span>
                  </Link>

                  <a
                    href="https://meetings.hubspot.com/viacheslav-seifer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-epic-secondary"
                  >
                    <motion.span
                      className="btn-content"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <span className="btn-text">קבעו שיחת ייעוץ</span>
                      <i className="las la-calendar-check btn-icon"></i>
                    </motion.span>
                  </a>

                  {/* <Link
                    to="/MARKETPLACE"
                    state={{ language: 'he' }}
                    className="btn-epic-tertiary"
                  >
                    <motion.span
                      className="btn-content"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <span className="btn-text">מרקטפלייס</span>
                      <i className="las la-store btn-icon"></i>
                    </motion.span>
                  </Link> */}

                  {/* <a
                    href="https://my.epicfinal.com/index.php?rp=%2Flogin&language=hebrew&currency=2"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-epic-quaternary"
                  >
                    <motion.span
                      className="btn-content"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <span className="btn-text">אזור ניהול אחסון אתרים וענן</span>
                      <i className="las la-cloud btn-icon"></i>
                      <span className="btn-shine"></span>
                    </motion.span>
                  </a> */}
                </motion.div>


                {/* Stats Row */}
                {/* <motion.div
                  className="hero-stats-epic"
                  initial={{ y: 30, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 1, delay: 1.1 }}
                >
                  <div className="stat-item">
                    <div className="stat-number">תוכנה</div>
                  </div>
                  <div className="stat-divider"></div>
                  <div className="stat-item">
                    <div className="stat-number">אבטחה</div>
                  </div>
                  <div className="stat-divider"></div>
                  <div className="stat-item">
                    <div className="stat-number">ענן</div>
                  </div>
                </motion.div> */}

                {/* Trust Badges */}

              </motion.div>
            </Col>
          </Row>
        </Container>

        {/* Scroll Indicator */}
        <motion.div
          className="scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.5 }}
        >
          <div className="scroll-mouse">
            <div className="scroll-wheel"></div>
          </div>
          <span className="scroll-text">גלול למטה</span>
        </motion.div>
      </motion.div>

      <section className="solutions-spotlight-section" aria-labelledby="solutions-spotlight-title">
        <Container>
          <motion.div
            className="solutions-spotlight-shell"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="solutions-spotlight-header">
              {/* <span className="solutions-spotlight-kicker">{'\u05d4\u05e4\u05ea\u05e8\u05d5\u05e0\u05d5\u05ea \u05e9\u05dc\u05e0\u05d5'}</span> */}
              <h2 id="solutions-spotlight-title" className="section-title solutions-spotlight-title">
                פתרונות טכנולוגיים
                <span>לעסקים בינוניים בצמיחה</span>
              </h2>
              <p className="solutions-spotlight-intro">
                {/* {'\u05d2\u05dc\u05d5\u05dc \u05d1\u05d9\u05df \u05db\u05dc \u05ea\u05d7\u05d5\u05de\u05d9 \u05d4\u05e4\u05e2\u05d9\u05dc\u05d5\u05ea \u05e9\u05dc\u05e0\u05d5. \u05db\u05dc \u05e4\u05e2\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05d0\u05d7\u05d3 \u05e2\u05d5\u05dc\u05d4 \u05dc\u05e7\u05d3\u05de\u05ea \u05d4\u05d1\u05de\u05d4, \u05d5\u05d4\u05e9\u05d0\u05e8 \u05e0\u05e9\u05d0\u05e8\u05d9\u05dd \u05d1\u05e8\u05e7\u05e2.'} */}
              </p>
            </div>

            <div className="solutions-spotlight-stage">
              <div className="solutions-spotlight-desktop-arrows" aria-hidden="false">
                <button
                  type="button"
                  className="spotlight-arrow spotlight-arrow-prev"
                  onClick={() => scrollSpotlightTrack('prev')}
                  aria-label="הצג פתרון קודם"
                >
                  <i className="las la-angle-right"></i>
                </button>
                <button
                  type="button"
                  className="spotlight-arrow spotlight-arrow-next"
                  onClick={() => scrollSpotlightTrack('next')}
                  aria-label="הצג פתרון הבא"
                >
                  <i className="las la-angle-left"></i>
                </button>
              </div>

              <div className="solutions-spotlight-progress" aria-hidden="true">
                {features.map((feature, index) => (
                  <button
                    key={feature.title}
                    type="button"
                    className={`spotlight-dot ${activeFeatureIndex === index ? 'is-active' : ''}`}
                    onClick={() => scrollToFeature(index)}
                    aria-label={feature.title}
                  />
                ))}
              </div>

              <div className="solutions-spotlight-track" ref={spotlightTrackRef}>
                {features.map((feature, index) => (
                  <motion.div
                    key={feature.title}
                    data-feature-index={index}
                    className={`modern-feature-card spotlight-card ${activeFeatureIndex === index ? 'is-active' : 'is-muted'}`}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.04 }}
                    onClick={() => navigate(feature.path)}
                  >
                    <div className="feature-icon" style={{ background: feature.background }}>
                      <i className={feature.icon}></i>
                    </div>
                    <div className="feature-content">
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                    </div>
                    <div className="feature-arrow">
                      <i className="las la-arrow-left"></i>
                    </div>
                  </motion.div>
                ))}
              </div>

              <div className="solutions-spotlight-mobile-arrows">
                <button
                  type="button"
                  className="spotlight-arrow spotlight-arrow-prev"
                  onClick={() => scrollSpotlightTrack('prev')}
                  aria-label="הצג פתרון קודם"
                >
                  <i className="las la-angle-right"></i>
                </button>
                <button
                  type="button"
                  className="spotlight-arrow spotlight-arrow-next"
                  onClick={() => scrollSpotlightTrack('next')}
                  aria-label="הצג פתרון הבא"
                >
                  <i className="las la-angle-left"></i>
                </button>
              </div>
            </div>

            <div className="solutions-spotlight-subscription-note">
              <p>
                כל הפתרונות המוצגים כאן כלולים במנוי <strong>DevSecOps ONE</strong>
              </p>
              <Link to="/pricing-he" className="solutions-spotlight-subscription-link">
                לפרטי המנוי
                <i className="las la-arrow-left" aria-hidden="true"></i>
              </Link>
            </div>

          </motion.div>
        </Container>
      </section>

      <section className="genai-promo-section">
        <Container>
          <motion.div
            className="genai-promo-banner"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.08 }}
          >
            <div className="genai-promo-copy">
              <span className="genai-promo-badge">חדש!</span>
              <h3>GenAI - סביבת בינה מלאכותית לפיתוח אפליקציות</h3>
              <p>
                הפכו רעיון לאפליקציה מהר יותר עם AI. בנו, בדקו והציגו גרסאות בסביבת עבודה מוכנה, והריצו את הפרויקט שלכם בענן.
              </p>

              <div className="genai-promo-points">
                <span><i className="las la-check-circle"></i>100 הודעות AI בכל חבילה</span>
                <span><i className="las la-check-circle"></i>סביבת עבודה בענן</span>
                <span><i className="las la-check-circle"></i>גמיש לפרויקטים בכל גודל</span>
              </div>

              <Link to="/he/genai" className="category-btn genai-promo-btn">
                הכירו את GenAI
                <i className="las la-arrow-left"></i>
              </Link>
            </div>

            <div className="genai-promo-visual" aria-hidden="true">
              <div className="genai-promo-window">
                <div className="genai-promo-window-top">
                  <div className="genai-promo-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <span className="genai-promo-chip">Dedicated VM</span>
                </div>

                <div className="genai-promo-prompt">
                  <strong>Prompt</strong>
                  <p>בנה לי פורטל לקוחות עם התחברות, דשבורד, הזמנות ואזור ניהול.</p>
                </div>

                <div className="genai-promo-flow">
                  <div className="genai-promo-flow-item">
                    <small>01</small>
                    <span>מאפיינים</span>
                  </div>
                  <div className="genai-promo-flow-item">
                    <small>02</small>
                    <span>בונים עם בינה מלאכותית</span>
                  </div>
                  <div className="genai-promo-flow-item">
                    <small>03</small>
                    <span>מציגים בסביבת עבודה</span>
                  </div>
                  <div className="genai-promo-flow-item">
                    <small>04</small>
                    <span>מריצים בשרת ייעודי</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </Container>
      </section>

      {/* Unified small-business growth journey */}
      <section className="smb-solutions-section" aria-labelledby="smb-solutions-title">
        <Container>
          <motion.div
            className="smb-solutions-shell"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6 }}
          >
            <div className="smb-solutions-heading">
              <span className="smb-solutions-kicker">
                <i className="las la-store" aria-hidden="true"></i>
                נבנה במיוחד לעסקים קטנים
              </span>
              <h2 id="smb-solutions-title">שלושה פתרונות לעסק קטן. כל אחד פותר צורך אחר.</h2>
              <p>מהבאת לקוחות חדשים, דרך הקמת נוכחות דיגיטלית מקצועית, ועד שיפור המערכות והתפעול שמאחורי העסק.</p>
            </div>

            <div className="smb-solutions-grid">
              <article className="smb-solution-card smb-solution-card--marketing">
                <div className="smb-solution-card-top">
                  <span className="smb-solution-number">01</span>
                  <span className="smb-solution-icon"><i className="las la-chart-line"></i></span>
                </div>
                <div className="smb-promo-header">epicfinal / GROWTH</div>
                <h3 className="smb-promo-title">הנדסת GTM ו־Pipeline לשיווק, לידים ומכירות</h3>
                <p id="growth-marketing-desc" className="smb-promo-desc">מערכות שיווק שמחברות בין יצירת ביקוש, פרסום, פניות, מעקב אחר לידים ומכירות — מהחשיפה הראשונה ועד לסגירת העסקה.</p>
                <a
                  href="https://growth.epicfinal.com/"
                  target="_blank"
                  rel="noopener noreferrer external"
                  className="smb-promo-button"
                  aria-label="מעבר לאתר שיווק, דאטה וצמיחה"
                  aria-describedby="growth-marketing-desc"
                >
                  לאתר הצמיחה
                  <i className="las la-external-link-alt"></i>
                </a>
              </article>

              <article className="smb-solution-card smb-solution-card--promo">
                <div className="smb-solution-card-top">
                  <span className="smb-solution-number">02</span>
                  <span className="smb-solution-icon"><i className="las la-laptop-code"></i></span>
                </div>
                <div className="smb-promo-header">שירות חיצוני • EPICFINAL PROMO</div>
                <h3 id="smb-promo-title" className="smb-promo-title">הקמה וניהול אתרים וחנויות לעסקים קטנים</h3>
                <p id="smb-promo-desc" className="smb-promo-desc">אתר מקצועי בהתאמה אישית, כולל דומיין, אחסון מנוהל ותמיכה לשנה — מהיר, מאובטח ומוכן לפרסום ולקידום.</p>
                <a
                  href="https://promo.eu.epicfinal-cloud.com/"
                  target="_blank"
                  rel="noopener noreferrer external"
                  className="smb-promo-button"
                  onClick={(event) => handleSmbPromoClick(event, 'https://promo.eu.epicfinal-cloud.com/')}
                  aria-label="פתח חבילות לעסקים קטנים באתר המבצע"
                  aria-describedby="smb-promo-desc"
                >
                  מעבר לחבילות
                  <i className="las la-external-link-alt"></i>
                </a>
              </article>

              <article className="smb-solution-card smb-solution-card--technology">
                <div className="smb-solution-card-top">
                  <span className="smb-solution-number">03</span>
                  <span className="smb-solution-icon"><i className="las la-layer-group"></i></span>
                </div>
                <div className="smb-promo-header">ליווי טכנולוגי • epicfinal</div>
                <h3 id="tech-growth-promo-title" className="smb-promo-title">מערכות ותפעול לעסקים בצמיחה</h3>
                <p id="tech-growth-promo-desc" className="smb-promo-desc">שיפור העבודה הפנימית באמצעות מערכות ניהול, אוטומציה תפעולית, דשבורדים וכלים טכנולוגיים שעוזרים לעסק לעבוד בצורה מסודרת, יעילה ומוכנה להתרחבות.</p>
                <Link
                  to="/he/tech-growth"
                  className="smb-promo-button"
                  aria-label="מעבר לדף ליווי טכנולוגי לעסקים בצמיחה"
                  aria-describedby="tech-growth-promo-desc"
                >
                  למידע נוסף
                  <i className="las la-arrow-left"></i>
                </Link>
              </article>
            </div>

            <div className="smb-solutions-audience-note">
              <p>
                השירותים בעמוד זה נבנו במיוחד לעסקים קטנים בעלי מחזור שנתי של עד 20 מיליון ₪.
              </p>
              <span className="smb-solutions-audience-divider" aria-hidden="true"></span>
              <p>
                לעסקים בינוניים הזקוקים לפיתוח, אבטחה ותשתיות באופן שוטף —{' '}
                <Link to="/pricing-he">הכירו את DevSecOps ONE</Link>
              </p>
            </div>

          </motion.div>
        </Container>
      </section>

      {/* Organizations & real-world experience showcase */}
      <section id="about-us" className="organizations-landscape-section org-showcase" aria-labelledby="org-expertise-title">
        <Container>
          <motion.div
            className="org-showcase-header"
            initial={{ y: 35, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.65 }}
          >
           
            <h2 id="org-expertise-title">
              מומחיות טכנולוגית שנבחנה
              <span>בארגונים ובפרויקטים אמיתיים</span>
            </h2>
            <p>
              המומחיות שלנו מבוססת על עבודה ישירה בתוך ארגונים, מעורבות מעשית בפרויקטים
              ותפעול שוטף של מערכות דיגיטליות בסביבות אמיתיות.
            </p>
          </motion.div>

          <div className="org-showcase-layout">
            <motion.article
              className="org-showcase-panel org-showcase-panel--enterprise"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: 0.12 }}
            >
              <div className="org-showcase-panel-header">
                <span className="org-showcase-panel-icon"><i className="las la-building" aria-hidden="true"></i></span>
                <div>
                  <span className="org-showcase-panel-label">מעורבות ישירה בתוך ארגונים</span>
                  <h3>ארגונים ופרויקטים שהיינו מעורבים בהם</h3>
                  <p>עבודה מעשית לצד צוותים בסביבות ציבוריות, תעשייתיות, חינוכיות ודיגיטליות.</p>
                </div>
              </div>

              <div className="org-showcase-grid">
                <a href="https://www.gov.il/he/departments/israel_national_cyber_directorate/govil-landing-page" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-shield-alt" aria-hidden="true"></i></span>
                  <span>מערך הסייבר הלאומי</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://jobs.vishay.com/iw/who-we-are/" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-microchip" aria-hidden="true"></i></span>
                  <span>ווישי טכנולוגיות</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://www.oneforisrael.org/" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-globe" aria-hidden="true"></i></span>
                  <span>OneForIsrael.org</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://biblecollege.co.il/" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-graduation-cap" aria-hidden="true"></i></span>
                  <span>המכללה למקרא</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://bible.new/" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-book-open" aria-hidden="true"></i></span>
                  <span>Bible.new</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://cyber.org.il/" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-code" aria-hidden="true"></i></span>
                  <span>המרכז לחינוך הסייבר</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
              </div>
            </motion.article>

            <motion.article
              className="org-showcase-panel org-showcase-panel--cloud"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: 0.24 }}
            >
              <div className="org-showcase-panel-header">
                <span className="org-showcase-panel-icon"><i className="las la-cloud" aria-hidden="true"></i></span>
                <div>
                  <span className="org-showcase-panel-label">מערכות פעילות בענן</span>
                  <h3>עסקים המופעלים על ידי שירותי אחסון ענן ופיתוח שלנו</h3>
                  <p>אחסון, פיתוח וליווי שוטף לאתרים ולמערכות עסקיות שנמצאים בשימוש יום־יומי.</p>
                </div>
              </div>

              <div className="org-showcase-grid">
                <a href="https://negev-dlatot.co.il/" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-door-open" aria-hidden="true"></i></span>
                  <span>נגב דלתות</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://electric-tools.co.il" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-tools" aria-hidden="true"></i></span>
                  <span>Electric Tools</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://abitbul-law.org/" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-balance-scale" aria-hidden="true"></i></span>
                  <span>אביטבול ושות׳ — משרד עורכי דין</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://photomark.co.il" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-camera" aria-hidden="true"></i></span>
                  <span>PhotoMark</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://modern-woman.co.il" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-user" aria-hidden="true"></i></span>
                  <span>אישה מודרנית</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
                <a href="https://shaiesh-haaretz.co.il/" target="_blank" rel="noopener noreferrer" className="org-showcase-link">
                  <span className="org-showcase-mark"><i className="las la-gem" aria-hidden="true"></i></span>
                  <span>שיש הארץ</span>
                  <i className="las la-arrow-left" aria-hidden="true"></i>
                </a>
              </div>
            </motion.article>
          </div>

          <motion.a
            href="https://tcb.ac.il/אודות/כללי"
            target="_blank"
            rel="noopener noreferrer"
            className="org-showcase-foundation"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <span className="org-showcase-foundation-icon"><i className="las la-award" aria-hidden="true"></i></span>
            <span>
              <small>הבסיס המקצועי שלנו</small>
              המובילים הטכנולוגיים שלנו הם בוגרי המכללה הטכנולוגית באר שבע, בעלת מורשת של למעלה משישים שנות הכשרה ומצוינות טכנולוגית.
            </span>
            <i className="las la-external-link-alt" aria-hidden="true"></i>
          </motion.a>
        </Container>
      </section>

      {/* Software Engineering Banner - Minimal */}
      <p className="minimal-software-text">
        תוכנה מצליחה היא הרבה מעבר לקוד — היא נשענת על <strong>ארכיטקטורה חזקה</strong>, <strong>אבטחה</strong>, <strong>תשתיות</strong>, <strong>בדיקות</strong>, <strong>ניטור</strong> ו<strong>תפעול מתמשך</strong>. <span className="brand-highlight">epicfinal</span> כאן כדי להאיץ את הצמיחה העסקית שלך עם שירותי הנדסת תוכנה מקצה לקצה.
      </p>

      {/* Hebrew Promo Video - Relocated below software engineering text */}
      <Container className="mb-5">
        <Row className="justify-content-center">
          <Col lg={6}>
            <motion.div
              className="hero-video"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              style={{
                position: 'relative',
                paddingBottom: '56.25%', /* 16:9 Aspect Ratio */
                height: 0,
                overflow: 'hidden',
                maxWidth: '100%',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                background: '#000000'
              }}
            >
              {isHebrewPromoPlaying ? (
                <iframe
                  src="https://www.youtube.com/embed/6w5OjndBR_E?autoplay=1&rel=0&playsinline=1"
                  title="Epicfinal Hebrew Promo"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 0
                  }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <button
                  type="button"
                  onClick={() => setIsHebrewPromoPlaying(true)}
                  aria-label="הפעלת הסרטון"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    padding: 0,
                    border: 0,
                    background: '#000000',
                    cursor: 'pointer'
                  }}
                >
                  <img
                    src="https://i.ytimg.com/vi/6w5OjndBR_E/maxresdefault.jpg"
                    alt=""
                    style={{
                      width: '100%',
                      height: '100%',
                      display: 'block',
                      objectFit: 'cover'
                    }}
                  />
                  <span
                    aria-hidden="true"
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      display: 'grid',
                      placeItems: 'center',
                      width: '64px',
                      height: '64px',
                      borderRadius: '50%',
                      color: '#ffffff',
                      background: 'rgba(0, 120, 168, 0.92)',
                      boxShadow: '0 10px 28px rgba(0, 0, 0, 0.28)',
                      fontSize: '28px'
                    }}
                  >
                    <i className="las la-play" />
                  </span>
                </button>
              )}
            </motion.div>
          </Col>
        </Row>
      </Container>

      {/* Platform Cards Section (Palo Alto–style) */}
      <section className="pan-platforms-section">
        <Container>
          <div className="pan-platforms">
            <Link to="/he/development" className="pan-platform-link">
              <div className="pan-platform-card">
                <div className="pan-platform-accent"></div>
                <div className="pan-platform-icon"><i className="las la-robot"></i></div>
                <h3>פיתוח תוכנה</h3>
                <p>ארכיטקטורה מודרנית, ביצועים גבוהים ו-UX מרשים – הכל בקוד נקי ומוכן לסקייל.</p>
                <ul>
                  <li><i className="las la-check"></i> React / Node.js / .NET / Python</li>
                  <li><i className="las la-check"></i> CI/CD, איכות קוד ואנליטיקות</li>
                  <li><i className="las la-check"></i>פיתוח מערכות WEB, Desktop ו-Mobile.</li>
                </ul>
                <div className="pan-platform-hint">
                  <span>לחצו לפרטים</span>
                  <i className="las la-arrow-left"></i>
                </div>
              </div>
            </Link>
            <Link to="/he/security" className="pan-platform-link">
              <div className="pan-platform-card">
                <div className="pan-platform-accent"></div>
                <div className="pan-platform-icon"><i className="las la-shield-alt"></i></div>
                <h3>אבטחת מידע וסייבר</h3>
                <p>תכנון מאובטח וניהול סיכונים – מוכנים לאתגר.</p>
                <ul>
                  <li><i className="las la-check"></i> Zero Trust & CDN</li>
                  <li><i className="las la-check"></i> מעקב, לוגים ו-Observability</li>
                  <li><i className="las la-check"></i>מערכות הגנה</li>
                </ul>
                <div className="pan-platform-hint">
                  <span>לחצו לפרטים</span>
                  <i className="las la-arrow-left"></i>
                </div>
              </div>
            </Link>
            <Link to="/he/operations" className="pan-platform-link">
              <div className="pan-platform-card">
                <div className="pan-platform-accent"></div>
                <div className="pan-platform-icon"><i className="las la-cloud"></i></div>
                <h3>ענן ו-DevOps</h3>
                <p>תשתיות גמישות, עלויות אופטימליות ופריסה מהירה – לכל שלב בצמיחה.</p>
                <ul>
                  <li><i className="las la-check"></i>Containerized - Cloud Native</li>
                  <li><i className="las la-check"></i>ענן פרטי והענן ציבורי</li>
                  <li><i className="las la-check"></i> ניטור וביצועים בזמן אמת</li>
                </ul>
                <div className="pan-platform-hint">
                  <span>לחצו לפרטים</span>
                  <i className="las la-arrow-left"></i>
                </div>
              </div>
            </Link>
          </div>
        </Container>
      </section>

      {/* Services Categories Section */}
      <section className="services-categories-section">
        <Container>
          <motion.div
            id="hosting-cloud"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="section-header text-center"
          >
            <h2 className="section-title">שירותי אחסון וניהול</h2>
          </motion.div>

          <div className="services-categories-grid">
            {/* אחסון אתרים Category */}
            <motion.div
              className="service-category-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              <div className="category-header">
                <i className="las la-server"></i>
                <h3>אחסון אתרים</h3>
              </div>
              <p className="category-description">
                פתרונות אחסון מהירים ומאובטחים לאתרים ויישומים
              </p>
              <ul className="services-list">
                <li>
                  <i className="las la-check-circle"></i>
                  <span>פאנל ניהול מתקדם</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>מערכת הגנה</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>SSL אוטומטי</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>אינטגרציה עם Cloudflare</span>
                </li>
              </ul>
              <div className="category-price">
                החל מ-<strong>₪19.90</strong> לחודש
              </div>
              <a
                href="https://my.epicfinal.com/index.php?rp=%2Fstore%2Fcloud-web-hosting&language=hebrew&currency=2"
                target="_blank"
                rel="noopener noreferrer"
                className="category-btn"
              >
                לפרטים נוספים <i className="las la-arrow-left"></i>
              </a>
            </motion.div>

            {/* שרתים וירטואליים Category */}
            <motion.div
              className="service-category-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <div className="category-header">
                <i className="las la-microchip"></i>
                <h3>שרתים וירטואליים</h3>
              </div>
              <p className="category-description">
                שרתים וירטואליים עוצמתיים עם משאבים ייעודיים
              </p>
              <ul className="services-list">
                <li>
                  <i className="las la-check-circle"></i>
                  <span>שרת Core - 4 vCPU, 8 RAM</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>שרת Edge - 8 vCPU, 16 RAM</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>שרת MTI-L - 16 vCPU, 35 RAM</span>
                </li>
              </ul>
              <ul className="services-list">
                <li>
                  <i className="las la-check-circle"></i>
                  <span>פאנל ניהול מתקדם</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>גישת ROOT מלאה</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>כתובת IPv4 יעודית</span>
                </li>
              </ul>
              <p className="category-note">
                <i className="las la-tools"></i> אפשרות לניהול מלא של השרת
              </p>
              <a
                href="https://my.epicfinal.com/index.php?rp=%2Fstore%2Fcompute&language=hebrew&currency=2"
                target="_blank"
                rel="noopener noreferrer"
                className="category-btn"
              >
                לפרטים נוספים <i className="las la-arrow-left"></i>
              </a>
            </motion.div>

            {/* WordPress Category */}
            <motion.div
              className="service-category-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
            >
              <div className="category-header">
                <i className="lab la-wordpress"></i>
                <h3>WordPress</h3>
              </div>
              <p className="category-description">
                פתרונות WordPress מנוהלים ולא מנוהלים
              </p>
              <ul className="services-list">
                <li>
                  <i className="las la-check-circle"></i>
                  <span>פאנל ניהול</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>עדכונים אוטומטיים</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>מערכת הגנה</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>SSL אוטומטי</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>אינטגרציה עם Cloudflare</span>
                </li>
              </ul>
              <div className="category-price">
                החל מ-<strong>₪19.90</strong> לחודש
              </div>
              <a
                href="https://my.epicfinal.com/index.php?rp=%2Fstore%2Fwordpress-hosting&language=hebrew&currency=2"
                target="_blank"
                rel="noopener noreferrer"
                className="category-btn"
              >
                לפרטים נוספים <i className="las la-arrow-left"></i>
              </a>
            </motion.div>

            {/* מרקטפלייס - Marketplace - Landscape Card */}
            {/* מרקטפלייס - Marketplace - Landscape Card */}
            {/* מרקטפלייס - Marketplace - Landscape Card */}
            <motion.div
              className="service-category-card landscape-card marketplace-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.35 }}
            >
              <div className="category-content-wrapper">
                <div className="category-info">
                  <div className="category-header" style={{ marginBottom: '1rem' }}>
                    <i className="las la-store"></i>
                    <div className="header-text">
                      <h3>Cloud Marketplace</h3>
                      <span className="price-label">החל מ-₪219 לחודש</span>
                    </div>
                  </div>

                  <p className="category-description" style={{ marginBottom: '0.75rem' }}>הפעלת יישומי ענן וסוכני AI בסביבה ייעודית, מבודדת ומנוהלת משלך.</p>

                  <div className="specs-line">
                    <span className="spec-item"><i className="las la-microchip"></i> 1 Core</span>
                    <span className="spec-item"><i className="las la-memory"></i> 2GB RAM</span>
                    <span className="spec-item"><i className="las la-hdd"></i> 100GB SSD</span>
                  </div>

                  <Link
                    to="/marketplace"
                    state={{ language: 'he' }}
                    className="category-btn"
                  >
                    <span>גלה מוצרי ענן</span>
                    <i className="las la-arrow-left btn-icon"></i>
                  </Link>
                </div>

                <ul className="services-list">
                  <li><i className="las la-check-circle"></i> <span>ניהול מלא, גיבויים ואבטחת סייבר</span></li>
                  <li><i className="las la-check-circle"></i> <span>ניטור 24/7 ותמיכה טכנית מדווחת</span></li>
                  <li><i className="las la-check-circle"></i> <span>תעודת SSL ותעבורה ללא הגבלה</span></li>
                  <li><i className="las la-check-circle"></i> <span>הטמעה מהירה</span></li>
                </ul>
              </div>
            </motion.div>

            {/* שירותים מנוהלים Category - Full Width Landscape */}
            <motion.div
              id="managed-services"
              className="service-category-card landscape-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
            >
              <div className="category-content-wrapper">
                <div className="category-info">
                  <div className="category-header">
                    <i className="las la-tools"></i>
                    <h3>שירותים מנוהלים</h3>
                  </div>
                  <p className="category-description">
                    שירותי ניהול מקצועיים לתשתיות ענן ושרתים עם תמיכה מלאה, ניטור 24/7 ומומחיות DevOps
                  </p>
                  <a
                    href="https://my.epicfinal.com/index.php?rp=%2Fstore%2Fmanaged-services&language=hebrew&currency=2"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="category-btn"
                  >
                    לפרטים נוספים <i className="las la-arrow-left"></i>
                  </a>
                </div>
                <ul className="services-list">
                  <li>
                    <i className="las la-check-circle"></i>
                    <Link to="/he/managed-cdn">CDN מנוהל - Cloudflare</Link>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <Link to="/he/server-management">ניהול שרתים חיצוניים</Link>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <Link to="/he/aws-management">ניהול AWS אוטומטי</Link>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <Link to="/he/aurora-database">מסד נתונים Aurora מנוהל</Link>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <Link to="/he/centralized-monitoring">ניטור וגיבוי מרכזי</Link>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <Link to="/he/devsecops-daily">מנוי DevOps לפי דרישה</Link>
                  </li>
                </ul>
              </div>
            </motion.div>

            {/* שירות הגנת סייבר מנוהל - Managed Cyber Defence - Full Width Landscape */}
            <motion.div
              className="service-category-card landscape-card cyber-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 }}
            >
              <div className="category-content-wrapper">
                <div className="category-info">
                  <div className="category-header">
                    <i className="las la-shield-alt"></i>
                    <h3>שירות הגנת סייבר מנוהל</h3>
                  </div>
                  <p className="category-description">
                    שירות הגנה מנוהל 24/7 עם ניטור רציף, זיהוי איומים ותגובה מודרכת לנקודות קצה וזהויות – ללא צורך בהקמת SOC פנימי
                  </p>
                  <div className="cyber-badges">
                    <span className="cyber-badge"><i className="lab la-windows"></i> Windows</span>
                    <span className="cyber-badge"><i className="lab la-linux"></i> Linux</span>
                    <span className="cyber-badge"><i className="las la-desktop"></i> עד 50 נקודות קצה</span>
                  </div>
                  <Link
                    to="/he/managed-cyber-defence"
                    className="category-btn cyber-btn"
                  >
                    לפרטים נוספים <i className="las la-arrow-left"></i>
                  </Link>
                </div>
                <ul className="services-list">
                  <li>
                    <i className="las la-check-circle"></i>
                    <span>ניטור 24/7 של נקודות קצה ופעילות משתמשים</span>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <span>חקירות איומים מובלות על ידי אנליסטים אנושיים</span>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <span>זיהוי מוקדם של איומים רציניים כולל Ransomware</span>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <span>הנחיות לבלימה ותיקון עם דוחות אירוע ברורים</span>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <span>שירות מנוהל</span>
                  </li>
                  <li>
                    <i className="las la-check-circle"></i>
                    <span>מודל שירות ללא צורך ב-SOC פנימי</span>
                  </li>
                </ul>
              </div>
              <div className="cyber-disclaimer">
                <i className="las la-info-circle"></i>
                <span>שירות זה אינו ביטוח סייבר ואינו מספק כיסוי כספי או משפטי</span>
              </div>
            </motion.div>
          </div>
        </Container>
      </section>

      {/* Features Grid */}
      <section className="features-section">
        <Container>
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="section-header text-center"
          >
            <h2 id="solutions" className="section-title">הפתרונות שלנו</h2>
          </motion.div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="modern-feature-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -10, transition: { duration: 0.2 } }}
                onClick={() => navigate(feature.path)}
              >
                <div className="feature-icon" style={{ background: feature.background }}>
                  <i className={feature.icon}></i>
                </div>
                <div className="feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
                <div className="feature-arrow">
                  <i className="las la-arrow-left"></i>
                </div>
              </motion.div>
            ))}
          </div>
        </Container>
      </section>

      {/* Marketing Keywords */}
      <section className="marketing-keywords-section">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="keywords-grid"
          >
            {[
              {
                title: "ללא נעילה לספק אחד",
                description: "חופש וגמישות מלאים בבחירת הטכנולוגיה שלך. הנתונים שלך – הכללים שלך, תמיד.",
                gradientStart: '#38bdf8',
                gradientEnd: '#818cf8',
                delay: 0.2
              },
              {
                title: "החלטות חכמות מבוססות נתונים",
                description: "אנחנו מקבלים החלטות על סמך מה שבאמת חשוב – הנתונים. מנתחים, מבינים, ופועלים מתוך תובנות אמיתיות.",
                gradientStart: '#8b5cf6',
                gradientEnd: '#d946ef',
                delay: 0.4
              },
              {
                title: "מיקוד בהתייעלות כלכלית",
                description: "מוציאים יותר מהתקציב שלך – עם פתרונות מדויקים שמספקים ערך אמיתי, בלי בזבוזים מיותרים.",
                gradientStart: '#14b8a6',
                gradientEnd: '#3b82f6',
                delay: 0.6
              }
            ].map((keyword, index) => (
              <motion.div
                key={index}
                className="keyword-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: keyword.delay }}
              >
                <div
                  className="card-content"
                  style={{
                    background: 'rgba(255, 255, 255, 0.03)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: '24px',
                    padding: '3rem 2rem',
                    border: '1px solid rgba(255, 255, 255, 0.05)',
                    position: 'relative'
                  }}
                >
                  <div
                    className="card-decorator"
                    style={{
                      width: '60px',
                      height: '60px',
                      marginBottom: '2rem',
                      background: `linear-gradient(135deg, ${keyword.gradientStart}, ${keyword.gradientEnd})`,
                      borderRadius: '16px',
                      transform: 'rotate(-10deg)'
                    }}
                  />
                  <h3
                    style={{
                      fontSize: '2rem',
                      background: `linear-gradient(135deg, ${keyword.gradientStart}, ${keyword.gradientEnd})`,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      marginBottom: '1.5rem'
                    }}
                  >
                    {keyword.title}
                  </h3>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#2D3748' }}>
                    {keyword.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </Container>
      </section>

      {/* DevSecOps ONE - Video & CTA Section */}
      <section className="devsecops-video-section">
        <Container>
          <motion.div
            className="devsecops-content-wrapper"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="devsecops-text-content">
              <h2 className="devsecops-title">
                <i className="las la-rocket"></i> DevSecOps ONE
              </h2>
              <h3 className="devsecops-subtitle">
                מנוי DevOps לפי דרישה - פרויקטים ללא הגבלה
              </h3>
              <p className="devsecops-description">
                הרשם עכשיו למנוי <strong>DevSecOps ONE</strong> ותצור <strong>פרויקטים ללא הגבלה</strong> בפלטפורמה.
              </p>
              <ul className="devsecops-features">
                <li>
                  <i className="las la-check-circle"></i>
                  <span>הערכת זמן לפרויקט אוטומטית</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>מידע על התקדמות בזמן אמת</span>
                </li>
                <li>
                  <i className="las la-check-circle"></i>
                  <span>בקשות ללא הגבלה</span>
                </li>
              </ul>
              <a
                href="/pricing-he"
                className="devsecops-cta-btn"
              >
                התחל מנוי עכשיו <i className="las la-arrow-left"></i>
              </a>
            </div>
            <div className="devsecops-video-content">
              <motion.div
                className="video-wrapper"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <iframe
                  src="https://www.youtube.com/embed/AsEa4XD4ZSA?si=y3wapsIHOB874gmc"
                  title="DevSecOps ONE Demo"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </motion.div>
            </div>
          </motion.div>
        </Container>
      </section>

      {/* Platform Onboarding */}
      <section className="platform-onboarding-section">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="platform-onboarding"
          >
            <h3 className="text-center">תהליך העבודה שלנו</h3>
            <div className="onboarding-steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-icon">🚀</div>
                <h4>צור פרויקט חדש</h4>
                <p>התחל מיד, בקלות ובמהירות</p>
              </div>

              <div className="step">
                <div className="step-number">2</div>
                <div className="step-icon">🎯</div>
                <h4>בחר את המסלול שלך ונתאם פגישה</h4>
                <p>קבל ייעוץ מומחה או התחל בהערכה חכמה</p>
              </div>

              <div className="step">
                <div className="step-number">3</div>
                <div className="step-icon">📊</div>
                <h4>עקוב אחר ההתקדמות</h4>
                <p>צפה בכל שלב דרך לוח הבקרה שלך</p>
              </div>

              <div className="step">
                <div className="step-number">4</div>
                <div className="step-icon">🎉</div>
                <h4>השלמת הפרויקט</h4>
                <p>קבל את קוד המקור או האישורים בקלות</p>
              </div>
            </div>

            <div className="platform-actions">
              <a
                href="https://epicfinal.com/he/platform"
                target="_blank"
                rel="noopener noreferrer"
                className="platform-btn primary">
                <span className="button-text">התחל עכשיו בפלטפורמה</span>
                <i className="las la-arrow-left"></i>
              </a>
              <a href="https://meetings.hubspot.com/viacheslav-seifer"
                className="platform-btn green"
                target="_blank"
                rel="noopener noreferrer">
                <span className="button-text">קבע פגישה</span>
                <i className="las la-calendar"></i>
              </a>
            </div>
          </motion.div>
        </Container>
      </section>

      {/* Cloud Service Section */}
      <section className="cloud-service-section">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="cloud-service-card"
          >
            <div className="cloud-service-content">
              <div className="cloud-service-icon">
                <i className="las la-cloud"></i>
              </div>
              <h3 className="cloud-service-title">תשתית ענן היברידי מנוהלת</h3>
              <p className="cloud-service-description">
                לארגונים וסטארטאפים. הקמה, ניהול ותחזוקה של תשתית ענן ייעודית מותאמת לאפליקציות, מוצרי SaaS ומערכות Production. פתרון יציב, מנוהל ומוכן לצמיחה.
              </p>
              <div className="cloud-service-price">
                החל מ-<strong>7,900 ₪</strong> לחודש | פלוס מע"מ
              </div>

              <Link to="/cloud" className="cloud-service-btn">
                <span>גלה עוד</span>
                <i className="las la-arrow-left"></i>
              </Link>
            </div>

          </motion.div>
        </Container>
      </section>

      {/* Call to Action */}
      <motion.section
        className="cta-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <Container>
          <div className="cta-content">
            <h2>מוכנים להתחיל?</h2>
            <p>צור קשר עוד היום ונתחיל לבנות את העתיד הדיגיטלי שלך</p>


            <div className="button-container">
              <a
                href="https://boarding.eu.epicfinal-cloud.com"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button primary"
              >
                התחל עכשיו
                <i className="las la-rocket ms-1"></i>
              </a>
              <a
                href="https://meetings.hubspot.com/viacheslav-seifer"
                className="cta-button secondary"
                target="_blank"
                rel="noopener noreferrer"
              >
                קבע פגישה
                <i className="las la-calendar ms-1"></i>
              </a>
            </div>
          </div>
        </Container>
      </motion.section>
    </div>
  );
}

export default FeatureL2he;

